/** @type {import('tailwindcss').Config} */

const colors = {
    white: "#FFFFFF",
    placeholderColor: "#B3B3B3",
    borderColor: "#D9D9D9",
    error: "#FF0400",
    black: "#000000",
    darkGray: "#1E1E1E",
    offWhite: "#FDFAF2",
    mdlzPurple: "#4F2170",
    mdlzPurple80: "#724E8D",
    mdlzPurple60: "#957AA9",
    mdlzPurple40: "#E0D4F2",
    mdlzPurpleShade: "#C3B0D8",
    goldenWheatDark: "#B46414",
    goldenWheat: "#E18719",
    goldenWheat80: "#EAAB5E",
    goldenWheat60: "#F3CFA3",
    tastyRed: "#A52323",
    tastyRed80: "#C97B7B",
    tastyRed60: "#E4BDBD",
    coolBlue: "#2D6EAA",
    coolBlue80: "#81A8CC",
    coolBlue60: "#ABC5DD",
    sunnyGrain: "#E6AF23",
    sunnyGrain80: "#EDC765",
    sunnyGrain60: "#F4DB9C",
    goGreen: "#287819",
    goGreen80: "#73A76A",
    goGreen60: "#B4D0AE",
    cocoaBrown: "#623E23",
    cocoaBrown80: "#917865",
    cocoaBrown60: "#B8A89C",
    coolGrey: "#646363",
    coolGrey80: "#878787",
    coolGrey60: "#9D9D9C",
    coolGrey40: "#E1E1E1",
}

module.exports = {
    content: [
        "./src/pages/**/*.{js,jsx,ts,tsx}",
        "./src/templates/**/*.{js,jsx,ts,tsx}",
        "./src/components/**/*.{js,jsx,ts,tsx}",
        "./src/assets/**/*.{js,jsx,ts,tsx}",
    ],
    safelist: [
        {
            pattern: /col-span-/,
            variants: ["xsm", "sm", "md", "lg", "xl"],
        },
        {
            pattern: /row-span-/,
            variants: ["xsm", "sm", "md", "lg", "xl"],
        },
        {
            pattern: /col-start-/,
            variants: ["xsm", "sm", "md", "lg", "xl"],
        },
        {
            pattern: /row-start-/,
            variants: ["xsm", "sm", "md", "lg", "xl"],
        },
        {
            pattern: /card-layout-(vertical|horizontal)/,
            variants: ["xsm", "sm", "md", "lg", "xl", "hover", "focus", "active"],
        },
    ],
    theme: {
        screens: {
            xl: "1440px",
            lg: "1120px",
            md: "834px",
            sm: "402px",
            xsm: "376px",
        },
        fontFamily: {
            bwSurco: "BwSurcoDEMO",
            mdlzBiteType: "MDLZBITETYPE",
            aauxPro: "AauxPro OT",
        },
        extend: {
            colors: {
                ...colors,
            },
            stroke: {
                ...colors,
            },
            fill: {
                ...colors,
            },
            placeholderColor: {
                ...colors,
            },
            flexGrow: {},
            spacing: {},
            fontSize: {},
            lineHeight: {},
            borderWidth: { 3: "3px" },
            borderRadius: {},
            inset: {
                auto: "auto",
            },
            height: {},
            minHeight: {
                auto: "auto",
            },
            maxWidth: {},
            minWidth: {},
            maxHeight: {},
            opacity: {},
            zIndex: {},
            gap: {},
            gridRow: {
                "span-7": "span 7 / span 7",
                "span-8": "span 8 / span 8",
            },
            backgroundImage: {},
            translate: {},
            transitionDuration: {},
            rotate: {},
            boxShadow: {},
            fontFamily: {},
            gridTemplateColumns: {
                10: "repeat(10, minmax(0, 1fr))",
            },
            gridTemplateRows: {
                10: "repeat(10, minmax(0, 1fr))",
            },
        },
    },
    variants: {
        extend: {
            stroke: ["hover"],
        },
    },
    plugins: [
        function ({ addVariant }) {
            addVariant("child", "& > *")
            addVariant("child-hover", "& > *:hover")
        },
    ],
}
